type Point = { x: number; y: number };
type StageGeometry = { width: number; height: number; x: number; y: number; scaleX: number; scaleY: number };

// Client coordinates and DOM bounds are both CSS pixels. Do not multiply by DPR.
export function drawingPoint(client: Point, bounds: { left: number; top: number; width: number; height: number }, stage: StageGeometry): Point | null {
  if (!bounds.width || !bounds.height || !stage.scaleX || !stage.scaleY) return null;
  return {
    x: ((client.x - bounds.left) * stage.width / bounds.width - stage.x) / stage.scaleX,
    y: ((client.y - bounds.top) * stage.height / bounds.height - stage.y) / stage.scaleY,
  };
}

export function createDrawingGesture() {
  let active: { id: number; target: HTMLElement; start: Point } | null = null;
  const cancel = () => {
    const previous = active;
    active = null;
    if (previous?.target.hasPointerCapture?.(previous.id)) previous.target.releasePointerCapture(previous.id);
  };
  return {
    begin(id: number, target: HTMLElement, start: Point) {
      if (active) return false;
      active = { id, target, start };
      target.setPointerCapture?.(id);
      return true;
    },
    matches: (id: number) => active?.id === id,
    finish(id: number) {
      if (active?.id !== id) return null;
      const start = active.start;
      cancel();
      return start;
    },
    cancel,
  };
}
